<template>
  <b-modal
    :dialog-class="modalClass"
    @shown="openForm"
    v-model="isShow"
    @hidden="$emit('close')"
    :hide-footer="isViewOnly"
    centered
  >
    <slot></slot>
    <template #modal-header>
      <h4 class="mb-0 text-primary">
        {{
          isViewOnly && isUpdate
            ? $t(detailTitle)
            : !isViewOnly && isUpdate
            ? $t(updateTitle)
            : $t(createTitle)
        }}
      </h4>
      <div class="d-flex align-items-center">
        <ez-icon
          v-if="isUpdate && (!apiCode || isValidPermission(apiCode))"
          :disabled="disableEditBtn"
          icon="ezAr-icon-edit"
          :class="{ 'cursor-pointer': disabledAndViewOnly }"
          class="mr-1"
          size="24"
          :color="disabledAndViewOnly ? '#ea5455' : '#ccc'"
          @click="handleClickEdit"
        />
        <ez-icon
          icon="ezAr-icon-x"
          class="cursor-pointer"
          size="24"
          color="#114A9F"
          @click="$emit('close')"
        />
      </div>
    </template>
    <template #modal-footer>
      <LoadingModalButton
        ref="buttonRef"
        :is-modal-hidden="!isShow"
        @click="submitModal"
        variant="primary"
        >{{ $t("ar_common_save") }}</LoadingModalButton
      >
    </template>
  </b-modal>
</template>

<script>
import { defineComponent, ref, watch } from "@vue/composition-api";
import LoadingModalButton from "../Button/LoadingModalButton.vue";

export default defineComponent({
  name: "ModalWithEditBtn",
  components: {
    LoadingModalButton,
  },
  props: {
    apiCode: String,
    isFormValid: Boolean,
    disableEditBtn: Boolean,
    dialogClass: String,
    isShow: Boolean,
    size: {
      type: String,
      default: "sm",
    },
    isUpdate: [Boolean, String, Object],

    updateTitle: String,
    createTitle: String,
    detailTitle: String,
  },
  setup() {
    const buttonRef = ref();
    const isLoading = ref(false);
    const startLoadingButton = () => {
      buttonRef.value.startLoading();
    };
    const stopLoadingButton = () => {
      buttonRef.value.stopLoading();
    };

    return { buttonRef, isLoading, startLoadingButton, stopLoadingButton };
  },
  data() {
    return {
      isViewOnly: false,
    };
  },
  methods: {
    handleClickEdit() {
      if (!this.isableEditBtn) {
        this.isViewOnly = false;
      }
      this.$emit("clickEdit");
    },
    submitModal() {
      this.$emit("submit");
    },
    openForm() {
      this.$emit("shown");
      if (this.isUpdate) {
        this.isViewOnly = true;
      }
    },
  },
  created() {},
  computed: {
    disabledAndViewOnly() {
      return this.isViewOnly && !this.disableEditBtn;
    },
    modalClass() {
      return {
        "custom-modal": true,
        [`${this.size}`]: true,
      };
    },
  },
  watch: {},
});
</script>
<style scoped>
::v-deep .custom-modal.sm {
  max-width: 576px;
}
::v-deep .custom-modal.md {
  max-width: 768px;
}
::v-deep .custom-modal.lg {
  max-width: 992px;
}

::v-deep .custom-modal.xl {
  max-width: 1200px;
}
</style>
